"use client";

import * as React from "react";
import { Link } from "@/components/common/Link";
import { Button } from "@/components/ui/button";
import { Separator } from "@/components/ui/separator";
const peakSeason = [{
  name: "Private Sessions",
  description: "Sunrise (6am – 8am) or Sunset (6pm-8pm)",
  price: "$100 per hour (minimum 1 hour)"
}, {
  name: "Semi-Private Sessions",
  description: "There could be other photographers/clients on the property at the same time.",
  price: "$50 per hour (minimum 1 hour)"
}];
const offSeason = [{
  name: "Private Sessions",
  description: "Enjoy exclusive access to the fields during our quieter months.",
  price: "$100 per hour (minimum 1 hour)"
}, {
  name: "Semi-Private Sessions",
  description: "Shared access with limited other guests.",
  price: "$50 per hour (minimum 1 hour)"
}];
export default function Pricing() {
  return <section id="pricing-section" className="bg-background py-16 md:py-24">
      <div className="container mx-auto px-4 max-w-5xl">
        <div className="text-center mb-12 md:mb-16">
          <h2 className="text-4xl md:text-5xl font-default text-foreground mb-6">
            Pricing and Booking Info
          </h2>
          <Separator className="w-16 h-0.5 bg-foreground mx-auto" />
        </div>

        <div className="grid md:grid-cols-2 gap-12 md:gap-16 mb-16">
          {}
          <div>
            <h3 className="text-2xl font-default text-foreground mb-6 border-b border-border pb-4">
              Peak Season Sessions
            </h3>
            <div className="space-y-8">
              {peakSeason.map((tier, i) => <div key={i} data-index={i} className="flex flex-col gap-1">
                  <h4 className="text-lg font-default font-semibold text-foreground">
                    {tier.name}{" "}
                    <span className="font-normal text-muted-foreground">
                      – {tier.description}
                    </span>
                  </h4>
                  <p className="text-foreground">{tier.price}</p>
                </div>)}
            </div>
          </div>

          {}
          <div>
            <h3 className="text-2xl font-default text-foreground mb-6 border-b border-border pb-4">
              Off-Season Sessions
            </h3>
            <div className="space-y-8">
              {offSeason.map((tier, i) => <div key={i} data-index={i} className="flex flex-col gap-1">
                  <h4 className="text-lg font-default font-semibold text-foreground">
                    {tier.name}{" "}
                    <span className="font-normal text-muted-foreground">
                      – {tier.description}
                    </span>
                  </h4>
                  <p className="text-foreground">{tier.price}</p>
                </div>)}
            </div>
          </div>
        </div>

        <div className="text-center space-y-6 flex flex-col items-center">
          <p className="text-2xl text-foreground font-default">
            Book Now with our Online Calendar!
          </p>
          <Button asChild size="lg" className="bg-primary hover:bg-primary/90 text-primary-foreground text-lg px-8 py-6 rounded-md uppercase tracking-wider w-fit">
            <Link to="#">BOOK ONLINE HERE</Link>
          </Button>
        </div>
      </div>
    </section>;
}